<template>
  <div class="broadcast-push-notification">
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <translate>The notification has been sent</translate>
          </b-alert>
          <b-form @submit.prevent="submitNotification">
            <b-form-row>
              <div class="form-group col-12 mb-3">
                <label for="change-status" v-translate>Send to</label>
                <div class="input-group mb-2">
                  <b-form-radio-group stacked v-model="sendTo" :options="sendToOptions"></b-form-radio-group>
                </div>
                <div class="input-group">
                  <b-form-select multiple v-model="notification.area_ids" :options="areasSelect" required :select-size="6" v-if="sendTo === 'areas'">
                  </b-form-select>
                </div>
              </div>
              <div class="form-group col-12">
                <label for="change-status" v-translate>Event Type</label>
                <div class="input-group">
                  <b-form-select v-model="notification.event_type" :options="eventTypesSelect" required>
                    <option value="communication" v-translate>Communication</option>
                  </b-form-select>
                </div>
              </div>
              <div class="form-group col-12">
                <label for="change-status" v-translate="{maxLength: maxMessageLength}">Message <em class="text-info"><small>(up to %{maxLength} characters)</small></em></label>
                <div class="input-group">
                  <b-form-textarea v-model="notification.message" rows="4" :state="notification.message.length === 0 ? null : notification.message.length <= maxMessageLength" required maxlength="255" />
                </div>
                <p class='text-right' v-bind:class="{'text-danger': notification.message.length > maxMessageLength }"><small>{{maxMessageLength - notification.message.length}}</small></p>
              </div>
            </b-form-row>
            <div class="text-right form-group col-12 form-actions">
              <b-button :disabled="sending" type="submit" variant="primary" size="lg" v-translate>Send Push Notification</b-button>
              <b-button :disabled="sending" variant="outline-primary" size="lg" @click.prevent="closeModal('modalNotificationForm')" v-translate>Cancel</b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'BroadcastPushNotification',
  data() {
    return {
      maxMessageLength: 255,
      dismissSecs: 5,
      dismissCountDown: 0,
      sending: false,
      sendTo: 'areas',
      sendToOptions: [
        // {
        //   text: 'All of Moova *** BE CAREFUL ***',
        //   value: 'all'
        // },
        {
          text: this.$gettextInterpolate(this.$gettext('All Areas in Current Country (%{country})'), {country: (window.country || this.$gettext('*** ALL COUNTRIES ***'))}),
          value: 'country'
        },
        {
          text: 'Selected Areas',
          value: 'areas'
        }
      ],
      notification: {
        area_ids: [],
        message: '',
        event_type: 'communication'
      }
    }
  },
  watch: {
    sendTo(val) {
      if (val !== 'areas') {
        this.notification.area_ids = []
      }
    }
  },
  created() {
    this.fetchAreas()
  },
  mounted() {
    if (!this.isSuperAdmin) {
      this.sendToOptions.shift()
    }
  },
  methods: {
    submitNotification() {
      if (
        confirm(
          this.$gettextInterpolate(this.$gettext('Are you sure you want to SEND the following message:\n\n======================\n%{mssg}\n======================\n\n%{toWhom}\n\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {mssg: this.notification.message, toWhom: (this.sendTo === 'all' ? this.$gettext('to ALL Moova') : this.$gettext('to the selected areas or country?'))})
        )
      ) {
        this.sending = true
        if (this.sendTo === 'all') {
          delete this.notification.area_ids
        } else if (this.sendTo === 'country') {
          this.notification.area_ids = this.areasSelect.map(x => { return x.value })
        }
        this.$http.post(this.$appConfig.api.baseUrl + 'push-notifications/broadcast', this.notification)
          .then(response => {
            this.showAlert()
            Object.assign(this.$data.notification, this.$options.data.call(this).notification)
          })
      }
    },
    closeModal(id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (this.dismissCountDown === 0) {
        this.closeModal('modalNotificationForm')
      }
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
